<div class="height-100 twc-d-flex flex-direction-column">
    <h4 class="twc-h4 twc-mb-0 cw-text-overflow-ellipsis"
        [twcTooltip]="'JOB_SITE.DETAIL.NAME' | translate : {jobSiteName : jobSiteDetail.name} ">
        {{ 'JOB_SITE.DETAIL.NAME' | translate : {jobSiteName : jobSiteDetail.name} }}
    </h4>

    <p class="twc-body font-bold cw-text-overflow-ellipsis" [twcTooltip]="jobSiteDetail.description">
        {{jobSiteDetail.description}}
    </p>

    <div class="twc-body twc-row twc-small twc-row-cols-1 twc-row-cols-sm-2 twc-row-cols-md-4 twc-rows-cols-lg-6 ">
        <p class="twc-col">
            <span class="font-bold">
                {{'OBJECT_BROWSER.CREATED' | translate}}:
            </span>
            {{jobSiteDetail.createdAt | localizedDate}}
        </p>
        <p class="twc-col">
            <span class="font-bold">
                {{'OBJECT_BROWSER.OPENED' | translate}}:
            </span>
            {{jobSiteDetail.accessedAt | localizedDate}}
        </p>
        <p class="twc-col">
            <span class="font-bold">
                {{'OBJECT_BROWSER.CREATED_BY' | translate}}:
            </span>
            {{jobSiteDetail.owner}}
        </p>
    </div>
    <cw-object-browser [loading]="isLoading" [mainButton]="mainButton" [pagination]="pagination"
        [footerSelectionResources]="footerSelectionResources" [browserViews]="browserViews"
        [columnDataList]="columnDataList" [data]="data" [dataType]="dataType" [reloadPage]="reloadPage"
        [secondaryButton]="goToViewerButton" [isMultiSelection]="true" (menuOptionClick)="onMenuOptionClick($event)"
        (pageChange)="onPageChanged($event)" (linkFieldClick)="onProjectNameClick($event)"
        (filterChange)="onFilterChange($event)" (dataRefresh)="onReload()" (delete)="onDelete()"
        (mainButtonAction)="openAddProjectPopup()">
    </cw-object-browser>
</div>